"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePortalArchivalAssetsPaginated = exports.queryKeys = exports.PAGE_SIZE = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

var _assetQueryKey = _interopRequireDefault(require("./assetQueryKey"));

var _excluded = ["filter"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PAGE_SIZE = 50;
exports.PAGE_SIZE = PAGE_SIZE;

var loadArchivalAssetsPaginated = function loadArchivalAssetsPaginated(portalId, derivationTime, pageNumber, filter) {
  return {
    type: 'LOAD_ARCHIVAL_ASSETS_V2_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: _objectSpread({
      pageSize: PAGE_SIZE,
      pageNumber: pageNumber,
      derivationTime: derivationTime
    }, filter ? {
      filter: filter
    } : {})
  };
};

var queryKeys = {
  all: function all(portalId, derivationTime) {
    var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return [].concat(_toConsumableArray((0, _assetQueryKey["default"])(portalId)), ['archival', 'paginated', derivationTime, filter]);
  }
};
exports.queryKeys = queryKeys;

var usePortalArchivalAssetsPaginated = function usePortalArchivalAssetsPaginated(portalId, derivationTime) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options$filter = options.filter,
      filter = _options$filter === void 0 ? '' : _options$filter,
      queryOptions = _objectWithoutProperties(options, _excluded);

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  return (0, _reactQuery.useInfiniteQuery)(_toConsumableArray(queryKeys.all(portalId, derivationTime, filter)), /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var _body$assets, _body$count;

      var _ref$pageParam, pageNumber, _yield$request, body;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$pageParam = _ref.pageParam, pageNumber = _ref$pageParam === void 0 ? 0 : _ref$pageParam;
              _context.next = 3;
              return request(loadArchivalAssetsPaginated(portalId, derivationTime, pageNumber, filter));

            case 3:
              _yield$request = _context.sent;
              body = _yield$request.body;
              return _context.abrupt("return", {
                assets: (_body$assets = body === null || body === void 0 ? void 0 : body.assets) !== null && _body$assets !== void 0 ? _body$assets : [],
                count: (_body$count = body === null || body === void 0 ? void 0 : body.count) !== null && _body$count !== void 0 ? _body$count : 0
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), _objectSpread(_objectSpread({
    staleTime: 120000,
    keepPreviousData: true
  }, queryOptions), {}, {
    // Must come after spread — callers cannot override the core NPI-3180 stop condition.
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      var _lastPage$count;

      return ((_lastPage$count = lastPage.count) !== null && _lastPage$count !== void 0 ? _lastPage$count : 0) < PAGE_SIZE ? undefined : allPages.length;
    }
  }));
};

exports.usePortalArchivalAssetsPaginated = usePortalArchivalAssetsPaginated;